import axios from "axios";
// import router from '../routerManuaConfig'
import router from "../router/index";
import store from "../store";
import Vue from "vue";

import applicationUserManager from "../Auth/applicationusermanager";

let base = "";
let Import = "http://import.qinghesuyang.yrtsedu.cn";
// 如果是IIS部署，用这个，因为 IIS 只能是 CORS 跨域，不能代理
// let base = process.env.NODE_ENV=="production"? 'http://localhost:8081':'';

// 请求延时
axios.defaults.timeout = 20000;

var storeTemp = store;
axios.interceptors.request.use(
  (config) => {
    var curTime = new Date();
    var expiretime = new Date(Date.parse(storeTemp.state.tokenExpire));

    if (
      storeTemp.state.token &&
      (curTime < expiretime && storeTemp.state.tokenExpire)
    ) {
      // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers.Authorization = "Bearer " + storeTemp.state.token;
    }

    saveRefreshtime();

    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);

// http response 拦截器
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // 超时请求处理
    var originalRequest = error.config;
    if (
      error.code == "ECONNABORTED" &&
      error.message.indexOf("timeout") != -1 &&
      !originalRequest._retry
    ) {
      Vue.prototype.$message({
        message: "请求超时！",
        type: "error",
      });

      originalRequest._retry = true;
      return null;
    }

    if (error.response) {
      if (error.response.status == 401) {
        var curTime = new Date();
        var refreshtime = new Date(Date.parse(window.localStorage.refreshtime));
        // 在用户操作的活跃期内
        if (window.localStorage.refreshtime && curTime <= refreshtime) {
          return refreshToken({
            token: window.localStorage.Token,
          }).then((res) => {
            if (res.success) {
              Vue.prototype.$message({
                message: "refreshToken success! loading data...",
                type: "success",
              });

              store.commit("saveToken", res.response.token);

              var curTime = new Date();
              var expiredate = new Date(
                curTime.setSeconds(
                  curTime.getSeconds() + res.response.expires_in
                )
              );
              store.commit("saveTokenExpire", expiredate);

              error.config.__isRetryRequest = true;
              error.config.headers.Authorization =
                "Bearer " + res.response.token;
              return axios(error.config);
            } else {
              // 刷新token失败 清除token信息并跳转到登录页面
              ToLogin();
            }
          });
        } else {
          // 返回 401，并且不知用户操作活跃期内 清除token信息并跳转到登录页面
          ToLogin();
        }
      }
      // 403 无权限
      if (error.response.status == 403) {
        Vue.prototype.$message({
          message: "失败！该操作无权限",
          type: "error",
        });
        return null;
      }
      // 429 ip限流
      if (error.response.status == 429) {
        Vue.prototype.$message({
          message: "刷新次数过多，请稍事休息重试！",
          type: "error",
        });
        return null;
      }
    }
    return ""; // 返回接口返回的错误信息
  }
);

export const BaseApiUrl = base;

// 登录
export const requestLogin = (params) => {
  return axios
    .get(`${base}/api/login/jwttoken3.0`, {
      params: params,
    })
    .then((res) => res.data);
};
export const requestLoginMock = (params) => {
  return axios.post(`${base}/login`, params).then((res) => res.data);
};

export const refreshToken = (params) => {
  return axios
    .get(`${base}/api/login/RefreshToken`, {
      params: params,
    })
    .then((res) => res.data);
};

export const saveRefreshtime = (params) => {
  let nowtime = new Date();
  let lastRefreshtime = window.localStorage.refreshtime ?
    new Date(window.localStorage.refreshtime) :
    new Date(-1);
  let expiretime = new Date(Date.parse(window.localStorage.TokenExpire));

  let refreshCount = 1; //滑动系数
  if (lastRefreshtime >= nowtime) {
    lastRefreshtime = nowtime > expiretime ? nowtime : expiretime;
    lastRefreshtime.setMinutes(lastRefreshtime.getMinutes() + refreshCount);
    window.localStorage.refreshtime = lastRefreshtime;
  } else {
    window.localStorage.refreshtime = new Date(-1);
  }
};
const ToLogin = (params) => {
  store.commit("saveToken", "");
  store.commit("saveTokenExpire", "");
  store.commit("saveTagsData", "");
  window.localStorage.removeItem("user");
  window.localStorage.removeItem("NavigationBar");

  if (global.IS_IDS4) {
    applicationUserManager.login();
  } else {
    router.replace({
      path: "/login",
      query: {
        redirect: router.currentRoute.fullPath,
      },
    });

    window.location.reload();
  }
};

export const getUserByToken = (params) => {
  return axios
    .get(`${base}/api/user/getInfoByToken`, {
      params: params,
    })
    .then((res) => res.data);
};

export function testapi2() {
  console.log("api is ok.");
}

export const testapi = (pa) => {
  console.log("api is ok.");
};

// 用户管理
export const getUserListPage = (params) => {
  return axios.get(`${base}/api/user/get`, {
    params: params,
  });
};
export const removeUser = (params) => {
  return axios.delete(`${base}/api/user/delete`, {
    params: params,
  });
};
export const editUser = (params) => {
  return axios.put(`${base}/api/user/put`, params);
};
export const addUser = (params) => {
  return axios.post(`${base}/api/user/post`, params);
};
export const batchRemoveUser = (params) => {
  return axios.delete(`${base}/api/Claims/BatchDelete`, {
    params: params,
  }); //没做
};

// 角色管理
export const getRoleListPage = (params) => {
  return axios.get(`${base}/api/role/get`, {
    params: params,
  });
};
export const removeRole = (params) => {
  return axios.delete(`${base}/api/role/delete`, {
    params: params,
  });
};
export const editRole = (params) => {
  return axios.put(`${base}/api/role/put`, params);
};
export const addRole = (params) => {
  return axios.post(`${base}/api/role/post`, params);
};

// 接口模块管理
export const getModuleListPage = (params) => {
  return axios.get(`${base}/api/module/get`, {
    params: params,
  });
};
export const removeModule = (params) => {
  return axios.delete(`${base}/api/module/delete`, {
    params: params,
  });
};
export const editModule = (params) => {
  return axios.put(`${base}/api/module/put`, params);
};
export const addModule = (params) => {
  return axios.post(`${base}/api/module/post`, params);
};

// 菜单模块管理
export const getPermissionListPage = (params) => {
  return axios.get(`${base}/api/permission/get`, {
    params: params,
  });
};
export const getPermissionTreeTable = (params) => {
  return axios.get(`${base}/api/permission/GetTreeTable`, {
    params: params,
  });
};
export const removePermission = (params) => {
  return axios.delete(`${base}/api/permission/delete`, {
    params: params,
  });
};
export const editPermission = (params) => {
  return axios.put(`${base}/api/permission/put`, params);
};
export const addPermission = (params) => {
  return axios.post(`${base}/api/permission/post`, params);
};
export const getPermissionTree = (params) => {
  return axios.get(`${base}/api/permission/getpermissiontree`, {
    params: params,
  });
};
export const getPermissionIds = (params) => {
  return axios.get(`${base}/api/permission/GetPermissionIdByRoleId`, {
    params: params,
  });
};

export const addRolePermission = (params) => {
  return axios.post(`${base}/api/permission/Assign`, params);
};
export const getNavigationBar = (params) => {
  return axios
    .get(`${base}/api/permission/GetNavigationBar`, {
      params: params,
    })
    .then((res) => res.data);
};

// Bug模块管理
export const getBugListPage = (params) => {
  return axios.get(`${base}/api/TopicDetail/get`, {
    params: params,
  });
};
export const removeBug = (params) => {
  return axios.delete(`${base}/api/TopicDetail/delete`, {
    params: params,
  });
};
export const editBug = (params) => {
  return axios.put(`${base}/api/TopicDetail/update`, params);
};
export const addBug = (params) => {
  return axios.post(`${base}/api/TopicDetail/post`, params);
};

// 博客模块管理
export const getBlogListPage = (params) => {
  return axios.get(`${base}/api/Blog`, {
    params: params,
  });
};
export const getBlogDeatil = (params) => {
  return axios.get(`${base}/api/Blog/DetailNuxtNoPer`, {
    params: params,
  });
};
export const editBlog = (params) => {
  return axios.put(`${base}/api/Blog/update`, params);
};
export const removeBlog = (params) => {
  return axios.delete(`${base}/api/Blog/delete`, {
    params: params,
  });
};

// 日志
export const getLogs = (params) => {
  return axios.get(`${base}/api/Monitor/get`, {
    params: params,
  });
};
export const getRequestApiinfoByWeek = (params) => {
  return axios.get(`${base}/api/Monitor/GetRequestApiinfoByWeek`, {
    params: params,
  });
};
export const getAccessApiByDate = (params) => {
  return axios.get(`${base}/api/Monitor/GetAccessApiByDate`, {
    params: params,
  });
};
export const getAccessApiByHour = (params) => {
  return axios.get(`${base}/api/Monitor/GetAccessApiByHour`, {
    params: params,
  });
};
export const getServerInfo = (params) => {
  return axios.get(`${base}/api/Monitor/Server`, {
    params: params,
  });
};
export const getAccessLogs = (params) => {
  return axios.get(`${base}/api/Monitor/GetAccessLogs`, {
    params: params,
  });
};

// Task管理
export const getTaskListPage = (params) => {
  return axios.get(`${base}/api/TasksQz/get`, {
    params: params,
  });
};
export const removeTask = (params) => {
  return axios.delete(`${base}/api/TasksQz/delete`, {
    params: params,
  });
};
export const editTask = (params) => {
  return axios.put(`${base}/api/TasksQz/put`, params);
};
export const addTask = (params) => {
  return axios.post(`${base}/api/TasksQz/post`, params);
};

export const startJob = (params) => {
  return axios.get(`${base}/api/TasksQz/StartJob`, {
    params: params,
  });
};
export const stopJob = (params) => {
  return axios.get(`${base}/api/TasksQz/StopJob`, {
    params: params,
  });
};
export const reCovery = (params) => {
  return axios.get(`${base}/api/TasksQz/ReCovery`, {
    params: params,
  });
};

///删除文章
export const Y_DeleteGetCouserText = (params) => {
  return axios.post(`${base}/api/Answer/Y_DeleteGetCouserText`, params);
};
///删除问题
export const Y_DeleteQuerstion = (params) => {
  return axios.post(`${base}/api/Answer/Y_DeleteQuerstion`, params);
};
///修改
export const Y_UpdateGetCouserText = (params) => {
  return axios.post(`${base}/api/Answer/Y_UpdateGetCouserText`, params);
};
//看单个
export const Y_GetCouserTextSingle = (params) => {
  return axios.get(`${base}/api/Answer/Y_GetCouserTextSingle`, {
    params: params,
  });
};
//添加文章

export const Y_AddGetCouserText = (params) => {
  return axios.post(`${base}/api/Answer/Y_AddGetCouserText`, params);
};
///文章列表

export const Y_GetCouserTextList = (params) => {
  return axios.get(`${base}/api/Answer/Y_GetCouserTextList`, {
    params: params,
  });
};
//问题分类管理

export const Y_GetSelects_CourseType = (params) => {
  return axios.get(`${base}/api/Answer/Y_GetSelects_CourseType`, {
    params: params,
  });
};
/// 获取 对应分类的所有的内容标题
export const Y_GetSelects_Course = (params) => {
  return axios.get(`${base}/api/Answer/Y_GetSelects_Course`, {
    params: params,
  });
};
//获取对应对内容的问题
export const Y_GetQuerstionList = (params) => {
  return axios.get(`${base}/api/Answer/Y_GetQuerstionList`, {
    params: params,
  });
};
//分配习题
export const Y_AddAllotQuerstion = (params) => {
  return axios.post(`${base}/api/Answer/Y_AddAllotQuerstion`, params);
};
//更换习题
export const Y_EaidAllotQuerstion = (params) => {
  return axios.post(`${base}/api/Answer/Y_EaidAllotQuerstion`, params);
};

//课后答题
export const Y_SelectQuerstionList = (params) => {
  return axios.get(`${base}/api/Answer/Y_SelectQuerstionList`, {
    params: params,
  });
};
//添加习题
export const Y_AddQuerstion = (params) => {
  return axios.post(`${base}/api/Answer/Y_AddQuerstion`, params);
};

//修改习题
export const Y_EditQuerstion = (params) => {
  return axios.post(`${base}/api/Answer/Y_EditQuerstion`, params);
};
//查看习题
export const Y_LookQuerstion = (params) => {
  return axios.get(`${base}/api/Answer/Y_LookQuerstion`, {
    params: params
  });
};

//获取分类列表
export const GetCateListByPage = (params) => {
  return axios.get(`${base}/api/back/YJYQuestion/MainGetCateInfo`, {
    params: params,
  });
};
export const BatchDeleteStudent = (params) => {
  return axios.post(`${base}/api/Back/BackTestStudent/BatchDeleteStudent`, params);
};
//添加分类
export const CateInfoAdd = (params) => {
  return axios.post(`${base}/api/back/YJYQuestion/MainSaveCate`, params);
};
//修改分类
export const CateInfoUpdate = (params) => {
  return axios.put(`${base}/api/back/YJYQuestion/MainUpdateCate`, params);
};

//删除分类
export const CateInfoDelete = (params) => {
  return axios.delete(`${base}/api/back/YJYQuestion/MainDeleteCate`, {
    params: params,
  });
};

//获取热门专题
export const GetHotQuestionListByPage = (params) => {
  return axios.get(`${base}/api/back/YJYQuestion/MainGetHotQuestionInfo`, {
    params: params,
  });
};

//添加热门专题
export const HotQuestionInfoAdd = (params) => {
  return axios.post(`${base}/api/back/YJYQuestion/AddHotQuestion`, params);
};

//修改热门专题
export const HotQuestionInfoUpdate = (params) => {
  return axios.put(`${base}/api/back/YJYQuestion/PutHotQuestion`, params);
};

//查询问题
export const GetQuestionListByPage = (params) => {
  return axios.get(`${base}/api/back/YJYQuestion/MainGetQuestionInfo`, {
    params: params,
  });
};

//通过
export const QuestionInfoUpdate = (params) => {
  return axios.put(`${base}/api/back/YJYQuestion/UpdateQuestionStatus`, params);
};
//驳回
export const RejectQuestionStatus = (params) => {
  return axios.put(`${base}/api/back/YJYQuestion/RejectQuestionStatus`, params);
};

//审核 家长评论是否通过
export const UpdateCommentStatus = (params) => {
  return axios.put(`${base}/api/back/YJYQuestion/UpdateCommentStatus`, params);
};

//删除问题
export const QuestionInfoDelete = (params) => {
  return axios.delete(`${base}/api/back/YJYQuestion/MainDeleteQuestion`, {
    params: params,
  });
};

//查询评论
export const GetCommentListByPage = (params) => {
  return axios.get(`${base}/api/back/YJYQuestion/MainGetCommentInfo`, {
    params: params,
  });
};

//删除评论
export const CommentInfoDelete = (params) => {
  return axios.delete(`${base}/api/back/YJYQuestion/MainDeleteComment`, {
    params: params,
  });
};

//获取单个 文章
export const GetArticlesSingle = (params) => {
  return axios.get(`${base}/api/Back/BackArticles/GetArticlesSingle`, {
    params: params,
  });
};
//获取课程列表 文章
export const GetArticlesListPage = (params) => {
  return axios.get(`${base}/api/Back/BackArticles/GetArticlesList`, {
    params: params,
  });
};
//消息详情
export const GetSchoolCustomerStatus = (params) => {
  return axios.get(`${base}/api/Back/BackMessage/GetSchoolCustomerStatus`, {
    params: params,
  });
};

//课程添加
export const addArticles = (params) => {
  return axios.post(`${base}/api/Back/BackArticles/Add`, params);
};
//删除消息通知  （暂时只支持单个删除）
export const DelMessage = (params) => {
  return axios.post(`${base}/api/Back/BackMessage/DelMessage`, params);
};
//获取课程列表
export const getcourseListPage = (params) => {
  return axios.get(`${base}/api/Back/BackStageCourse/GetPageList`, {
    params: params,
  });
};

///线下课程
export const GetActivitiesType = (params) => {
  return axios.get(`${base}/api/ActivityTypes/GetActivitiesType`, {
    params: params,
  });
};

//获取课程类型
export const getcoursetypes = (params) => {
  return axios.get(`${base}/api/Back/BackStageCourse/GetCoursesType`, {
    params: params,
  });
};

//课程添加
export const addcourses = (params) => {
  return axios.post(`${base}/api/Back/BackStageCourse/Add`, params);
};

//获取单个课程详情
export const getcoursesingle = (params) => {
  return axios.get(`${base}/api/Back/BackStageCourse/GetSingle`, {
    params: params,
  });
};
//获取单个课程类的子课程详情
export const GetCatalogsBackOne = (params) => {
  return axios.get(`${base}/api/Back/StageCatalogs/GetCatalogsBackOne`, {
    params: params,
  });
};

//课程修改
export const backcourseupdate = (params) => {
  return axios.put(`${base}/api/Back/BackStageCourse/Update`, params);
};
//文章修改
export const UpdateArticles = (params) => {
  return axios.put(`${base}/api/Back/BackArticles/UpdateArticles`, params);
};

//课程删除
export const coursedelete = (params) => {
  return axios.delete(`${base}/api/Back/BackStageCourse/Delete`, {
    params: params,
  });
};

//图片导入
export const UploadImg = (params) => {
  return axios.post(`${base}/api/Img/UploadImg`, params);
};

//文件导入 分片上传
export const OtherUpload = (params) => {
  return axios.post(`${base}/api/Img/UploadFilesPag`, params);
};

//获取课程子目录内容列表
export const getcoursecatalogs = (params) => {
  return axios.get(`${base}/api/Back/StageCatalogs/GetPageList`, {
    params: params,
  });
};

//新增
export const coursecatalogsadd = (params) => {
  return axios.post(`${base}/api/Back/StageCatalogs/Add`, params);
};

//修改
export const coursecatalogsupdate = (params) => {
  return axios.put(`${base}/api/Back/StageCatalogs/Update`, params);
};

//删除
export const coursecatalogsdelete = (params) => {
  return axios.delete(`${base}/api/Back/StageCatalogs/Delete`, {
    params: params,
  });
};

//根据类型获取课题标题列表
export const getCourseListBacks = (params) => {
  return axios.get(`${base}/api/Back/StageCatalogs/GetCourseListBacks`, {
    params: params,
  });
};

//活动管理
export const getactivitiespagelist = (params) => {
  return axios.get(`${base}/api/Back/BackActivities/GetPageList`, {
    params: params,
  });
};

//单个活动详情
export const activitiessingle = (params) => {
  return axios.get(`${base}/api/Back/BackActivities/GetSingle`, {
    params: params,
  });
};

//新增
export const activitiesadd = (params) => {
  return axios.post(`${base}/api/Back/BackActivities/Add`, params);
};

//删除
export const activitiesdelete = (params) => {
  return axios.delete(`${base}/api/Back/BackActivities/Delete`, {
    params: params,
  });
};

//修改
export const activitiesedit = (params) => {
  return axios.post(`${base}/api/Back/BackActivities/Edit`, params);
};

export const getactivitytype = (params) => {
  return axios.get(`${base}/api/ActivityTypes/GetAllActivitiesTypes`, {
    params: params,
  });
};

//获取注册用户列表
export const GetCustomerByPage = (params) => {
  return axios.get(`${base}/api/Back/BackCustomerInfo/GetCustomerByPage`, {
    params: params,
  });
};
//更新用户类型
export const UpdateCustomerType = (params) => {
  return axios.post(
    `${base}/api/Back/BackCustomerInfo/UpdateCustomerType`,
    params
  );
};

//获取教师班级权限树
export const GetPermissionTree = (params) => {
  return axios.get(`${base}/api/Back/BackCustomerInfo/GetPermissionTree`, {
    params: params,
  });
};
//保存 教师权限
export const SaveTeacherClassMap = (params) => {
  return axios.post(
    `${base}/api/Back/BackCustomerInfo/SaveTeacherClassMap`,
    params
  );
};
///获取 学生学分
export const GetStudentScore = (params) => {
  return axios.post(
    `${base}/api/app/AppHera_PopularScience/GetStudentScoreAdmin`,
    params
  );
};

///获取 学生学分 new
export const GetTaskProccessAdminByStu = (params) => {
  return axios.get(
    `${base}/api/Back/BackCustomerInfo/GetTaskProccessAdminByStu`, {
      params: params,
    });
};

///获取 家长学分
export const GetTaskProccessAdmin = (params) => {
  return axios.get(`${base}/api/Back/BackCustomerInfo/GetTaskProccessAdmin`, {
    params: params,
  });
};
///家长绑定学生
export const AddStudentMapCustomerInfo = (params) => {
  return axios.post(
    `${base}/api/Back/BackCustomerInfo/AddStudentMapCustomerInfo`,
    params
  );
};
//删除家长
export const DelCustomer = (params) => {
  return axios.post(`${base}/api/Back/BackCustomerInfo/DelCustomer`, params);
};

//获取分类
export const GetCateSelectByType = (params) => {
  return axios.post(
    `${base}/api/Back/BackTestPsych/GetCateSelectByType`,
    params
  );
}; //获取学届
export const GetYearsInfo = (params) => {
  return axios.post(`${base}/api/Back/BackTestPsych/GetYearsInfo`, params);
}; //获取年级
export const GetGradeInfo = (params) => {
  return axios.post(`${base}/api/Back/BackTestPsych/GetGradeInfo`, params);
}; //获取班级
export const GetClassInfo = (params) => {
  return axios.post(`${base}/api/Back/BackTestPsych/GetClassInfo`, params);
}; //获取数据
export const GetPsychMeasureByCateId = (params) => {
  return axios.post(
    `${base}/api/Back/BackEvalData/GetPsychMeasureByCateId`,
    params
  );
};
//获取建议列表
export const MainGetPersonproposal = (params) => {
  return axios.get(`${base}/api/back/BackProposal/MainGetPersonproposal`, {
    params: params,
  });
};

//获取课程内容柱状图
export const GetChartDataByYearGrade = (params) => {
  return axios.post(
    `${base}/api/Back/CourseLook/GetChartDataByYearGrade`,
    params
  );
}; //获取饼状图
export const GetYuanChartDataByYearGrade = (params) => {
  return axios.post(
    `${base}/api/Back/CourseLook/GetYuanChartDataByYearGrade`,
    params
  );
};
// 后台查询学生列表
export const GetStudentInfoByPage = (params) => {
  return axios.get(`${base}/api/Back/BackTestStudent/GetStudentInfoByPage`, {
    params: params,
  });
};

//发送消息
export const SchoolSendMsg = (params) => {
  return axios.post(`${base}/api/Back/BackMessage/SchoolSendMsg`, params);
};

//获取建议列表
export const SendmsgGetStudentInfoByPage = (params) => {
  return axios.get(`${base}/api/Back/BackTestStudent/GetStudentInfoByPage`, {
    params: params,
  });
};

//后台添加学生
export const AddStudent = (params) => {
  return axios.post(`${base}/api/Back/BackTestStudent/AddStudent`, params);
};
// 修改学生
export const UpdateStudent = (params) => {
  return axios.put(`${base}/api/Back/BackTestStudent/UpdateStudent`, params);
};
// 删除学生
export const DeleteStudent = (params) => {
  return axios.delete(`${base}/api/Back/BackTestStudent/DeleteStudent`, {
    params: params,
  });
};
// 后台重置密码
export const RestPassword = (params) => {
  return axios.post(`${base}/api/Back/BackTestStudent/RestPassword`, params);
};
// 获取周期列表
export const GetCycleInfoByPage = (params) => {
  return axios.get(`${base}/api/Back/BackTestCycle/GetCycleInfoByPage`, {
    params: params,
  });
};

// 获取分类select
export const GetSchoolMsgList = (params) => {
  return axios.get(`${base}/api/Back/BackMessage/GetSchoolMsgList`, {
    params: params,
  });
};
// 获取分类select
export const GetCateSelect = (params) => {
  return axios.get(`${base}/api/Back/BackTestCycle/GetCateSelect`, {
    params: params,
  });
};
// 获取心里分类
export const GetAdminTypeList = (params) => {
  return axios.get(`${base}/api/Back/WebHera_PopularScience/GetAdminTypeList`, {
    params: params,
  });
};
// 获取心里列表
export const GetaAdminHeraList = (params) => {
  return axios.get(
    `${base}/api/Back/WebHera_PopularScience/GetaAdminHeraList`, {
      params: params,
    }
  );
};
// 获取单个心里
export const GetAdminHeraDetails = (params) => {
  return axios.get(
    `${base}/api/Back/WebHera_PopularScience/GetAdminHeraDetails`, {
      params: params,
    }
  );
};
// 添加心里
export const AddHera_Popular = (params) => {
  return axios.post(
    `${base}/api/Back/WebHera_PopularScience/AddHera_Popular`,
    params
  );
};
//修改
export const ModifiHera_Popular = (params) => {
  return axios.post(
    `${base}/api/Back/WebHera_PopularScience/ModifiHera_Popular`,
    params
  );
};
// 删除
export const DelHera_Popular = (params) => {
  return axios.post(
    `${base}/api/Back/WebHera_PopularScience/DelHera_Popular`,
    params
  );
};
// 新增周期
export const AddCycle = (params) => {
  return axios.post(`${base}/api/Back/BackTestCycle/AddCycle`, params);
};
// 周期删除
export const DeleteCycle = (params) => {
  return axios.post(`${base}/api/Back/BackTestCycle/DeleteCycle`, params);
};
// 编辑周期
export const UpdateCycle = (params) => {
  return axios.put(`${base}/api/Back/BackTestCycle/UpdateCycle`, params);
};
// 周期开启
export const OpenCycle = (params) => {
  return axios.post(`${base}/api/Back/BackTestCycle/OpenCycle`, params);
};
// 周期关闭
export const CloseCycle = (params) => {
  return axios.post(`${base}/api/Back/BackTestCycle/CloseCycle`, params);
};
// 保存幼儿园基础数据
export const ExcelSaveFile = (params) => {
  return axios.post(`${base}/api/Back/BackTestStudent/ExcelSaveFile`, params);
};
//文件导入
export const UploadFileExcel = (params) => {
  return axios.post(`${base}/api/OtherFile/UploadFileExcel`, params);
};

// GetHostCoursesData

/**
 * 获取课程类别
 * @param {*} params
 * @returns
 */
export const GetHostCoursesData = (params) => {
  return axios.get(
    `${base}/api/Back/BackStageCourse/GetHostCoursesData`, {
      params
    }

  );
};

/**
 * 获取二级分类
 * @param {*} params
 * @returns
 */
export const GetCoursesTypeAdmin = (params) => {
  return axios.get(`${base}/api/Back/BackStageCourse/GetCoursesTypeAdmin`, {
    params,
  });
};
export const OpenQuestionInfo = (params) => {
  return axios.post(`${base}/api/back/YJYQuestion/OpenQuestionInfo`, params);
};
export const StopQuestion = (params) => {
  return axios.post(`${base}/api/back/YJYQuestion/StopQuestion`, params);
};
export const GetOptionGroup = (params) => {
  return axios.get(
    `${base}/api/back/YJYQuestion/GetOptionGroup`, {
      params
    }
  );
};
export const ImportExcelSaveFile = (params) => {
  return axios.post(`${base}/import/Back/Import/ImportExcelSaveFile`, params);
};
//文件导入
export const ImportUploadFileExcel = (params) => {
  return axios.post(`${base}/import/Back/Import/UploadFileExcel`, params);
};
export const GetLogInfo = (params) => {
  return axios.get(
    `${base}/api/LogDate/GetLogInfo`, {
      params
    }
  );
};
export const GetActionInfo = (params) => {
  return axios.get(
    `${base}/api/LogDate/GetActionInfo`, {
      params
    }
  );
};
export const AddRecordInfo = (params) => {
  return axios.post(`${base}/api/LogDate/AddRecordInfo`, params);
};
export const GetOnlineTeacherInfo = (params) => {
  return axios.get(
    `${base}/api/app/Online/GetOnlineTeacherInfo`, {
      params
    }
  );
};
export const AddOnlineTeacher = (params) => {
  return axios.post(`${base}/api/app/Online/AddOnlineTeacher`, params);
};
export const DeleteOnlineTeacher = (params) => {
  return axios.post(`${base}/api/app/Online/DeleteOnlineTeacher`, params);
};
export const GetWebStudentOnlineList = (params) => {
  return axios.get(
    `${base}/api/app/Online/GetWebStudentOnlineList`, {
      params
    }
  );
};
export const ApprovalOnlineInfo = (params) => {
  return axios.post(`${base}/api/app/Online/ApprovalOnlineInfo`, params);
};
export const SignOnlineInfo = (params) => {
  return axios.post(`${base}/api/app/Online/SignOnlineInfo`, params);
};
export const GetEP_PostByPage = (params) => {
  return axios.get(
    `${base}/api/v5/EP/GetEP_PostByPage`, {
      params
    }
  );
};
export const Get_MaskSelectInfo = (params) => {
  return axios.get(
    `${base}/api/v5/EP/Get_MaskSelectInfo`, {
      params
    }
  );
};
export const GetMaskTypesSelectInfo = (params) => {
  return axios.get(
    `${base}/api/v5/EP/GetMaskTypesSelectInfo`, {
      params
    }
  );
};
export const GetCheckStatusSelectInfo = (params) => {
  return axios.get(
    `${base}/api/v5/EP/GetCheckStatusSelectInfo`, {
      params
    }
  );
};
export const AddEP_MaskInfo = (params) => {
  return axios.post(`${base}/api/v5/EP/AddEP_MaskInfo`, params);
};
export const GetEP_MaskInfoByPage = (params) => {
  return axios.get(
    `${base}/api/v5/EP/GetEP_MaskInfoByPage`, {
      params
    }
  );
};
export const DeleteEP_MaskInfo = (params) => {
  return axios.post(`${base}/api/v5/EP/DeleteEP_MaskInfo`, params);
};
export const GetEP_MaskDetail = (params) => {
  return axios.get(
    `${base}/api/v5/EP/GetEP_MaskDetail`, {
      params
    }
  );
};

export const SaveEP_MaskInfo = (params) => {
  return axios.post(`${base}/api/v5/EP/SaveEP_MaskInfo`, params);
};
export const ToExamineEP_MaskInfo = (params) => {
  return axios.post(`${base}/api/v5/EP/ToExamineEP_MaskInfo`, params);
};
export const OC_EP_MaskInfo = (params) => {
  return axios.post(`${base}/api/v5/EP/OC_EP_MaskInfo`, params);
};
export const AddEP_PostInfo = (params) => {
  return axios.post(`${base}/api/v5/EP/AddEP_PostInfo`, params);
};
export const DeleteEP_PostInfo = (params) => {
  return axios.post(`${base}/api/v5/EP/DeleteEP_PostInfo`, params);
};
export const OC_EP_PostInfo = (params) => {
  return axios.post(`${base}/api/v5/EP/OC_EP_PostInfo`, params);
};
export const ToExamineEP_PostInfo = (params) => {
  return axios.post(`${base}/api/v5/EP/ToExamineEP_PostInfo`, params);
};
export const Get_EP_HouseWorkByPage = (params) => {
  return axios.get(
    `${base}/api/v5/EP/Get_EP_HouseWorkByPage`, {
      params
    }
  );
};
export const Get_PostSelectInfo = (params) => {
  return axios.get(
    `${base}/api/v5/EP/Get_PostSelectInfo`, {
      params
    }
  );
};
export const GetEP_DeliverInfoByPage = (params) => {
  return axios.get(
    `${base}/api/v5/EP/GetEP_DeliverInfoByPage`, {
      params
    }
  );
};
export const GetTeacherInfo = (params) => {
  return axios.get(
    `${base}/api/v5/EP/GetTeacherInfo`, {
      params
    }
  );
};
export const AddTeacherInfo = (params) => {
  return axios.post(`${base}/api/v5/EP/AddTeacherInfo`, params);
};
export const UpdateTeacherInfo = (params) => {
  return axios.post(`${base}/api/v5/EP/UpdateTeacherInfo`, params);
};
export const GetClassRole = (params) => {
  return axios.get(
    `${base}/api/v5/EP/GetClassRole`, {
      params
    }
  );
};
export const AddUserClassRole = (params) => {
  return axios.post(`${base}/api/v5/EP/AddUserClassRole`, params);
};
export const DeleteTeacherInfo = (params) => {
  return axios.post(`${base}/api/v5/EP/DeleteTeacherInfo`, params);
};
export const GetEP_PracticeInfoByPage = (params) => {
  return axios.get(
    `${base}/api/v5/EP/GetEP_PracticeInfoByPage`, {
      params
    }
  );
};
export const Eval_ForPracticeInfo = (params) => {
  return axios.post(`${base}/api/v5/EP/Eval_ForPracticeInfo`, params);
};

export const CheckEP_DeliverInfo = (params) => {
  return axios.post(`${base}/api/v5/EP/CheckEP_DeliverInfo`, params);
};
export const Eval_Stu_Mask_Post = (params) => {
  return axios.post(`${base}/api/v5/EP/Eval_Stu_Mask_Post`, params);
};
export const GetUnitList = (params) => {
  return axios.get(
    `${base}/api/v5/EP/GetUnitList`, {
      params
    }
  );
};
export const AddUnitInfo = (params) => {
  return axios.post(`${base}/api/v5/EP/AddUnitInfo`, params);
};
export const DeleteUnitInfo = (params) => {
  return axios.post(`${base}/api/v5/EP/DeleteUnitInfo`, params);
};
export const GetSJEP_PostByPage = (params) => {
  return axios.get(
    `${base}/api/v5/EP/GetSJEP_PostByPage`, {
      params
    }
  );
};
export const GetEP_PracticeInfoByPost = (params) => {
  return axios.get(
    `${base}/api/v5/EP/GetEP_PracticeInfoByPost`, {
      params
    }
  );
};
export const GetStudentSelect = (params) => {
  return axios.get(
    `${base}/api/v5/EP/GetStudentSelect`, {
      params
    }
  );
};
export const SaveEP_Stu_PracticeInfo = (params) => {
  return axios.post(`${base}/api/v5/EP/SaveEP_Stu_PracticeInfo`, params);
};
export const Delete_ForPracticeInfo = (params) => {
  return axios.post(`${base}/api/v5/EP/Delete_ForPracticeInfo`, params);
};
export const SP_ForPracticeInfo = (params) => {
  return axios.post(`${base}/api/v5/EP/SP_ForPracticeInfo`, params);
};
export const ImportPostStudent = (params) => {
  return axios.post(`${Import}/api/v5/EP/ImportPostStudent`, params);
};
export const GetTotalEPInfo = (params) => {
  return axios.get(
    `${base}/api/v5/EP/GetTotalEPInfo`, {
      params
    }
  );
};
export const GetEPScoreDetailInfo = (params) => {
  return axios.get(
    `${base}/api/v5/EP/GetEPScoreDetailInfo`, {
      params
    }
  );
};
export const UpdatePWD = (params) => {
  return axios.post(`${base}/api/User/UpdatePWD`, params);
};